<curbnturf-save-favorite [poi]="activity"></curbnturf-save-favorite>
<div class="poi-pin-outer">
  <div class="poi-header">
    <div class="poi-outer">
      <div
        *ngIf="activity?.hasActivity()"
        [ngClass]="{ selected: activitySelected }"
        (click)="activitySelected = !activitySelected"
        class="poi-activities"
      >
        <curbnturf-category-svg icon="activity" [white]="activitySelected"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryDump" class="poi-dump-station">
        <curbnturf-category-svg icon="dump"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryRestArea" class="poi-rest-stops">
        <curbnturf-category-svg icon="restArea"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryWifi" class="poi-wifi">
        <curbnturf-category-svg icon="wifi"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryPotableWater" class="poi-fresh-water">
        <curbnturf-category-svg icon="potableWater"> </curbnturf-category-svg>
      </div>
      <div *ngIf="activity?.categoryPropane" class="poi-lpg">
        <curbnturf-category-svg icon="propane"> </curbnturf-category-svg>
      </div>
    </div>
    <div class="poi-profile-outer">
      <img
        *ngIf="activity?.user?.photo"
        src="{{ getUserPhotoUrl(activity?.user?.photo) }}"
        alt="{{ activity?.user?.photo?.caption }}"
        class="user-image _60px"
      />
      <div class="w-hidden-small w-hidden-tiny">{{ activity?.user?.firstName }} {{ activity?.user?.lastName }}.</div>
      <a *ngIf="activity?.user?.id === currentUser?.id" (click)="onEditActivity()" class="link"> Edit Info </a>
      <div class="horz-line"></div>
    </div>
  </div>
  <div *ngIf="activitySelected" class="offsite-poi-inner published">
    <div class="offsite-activities-poi-inner published">
      <div *ngIf="activity?.activityBiking" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="biking"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Biking</div>
      </div>
      <div *ngIf="activity?.activityBoating" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="boating"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Boating</div>
      </div>
      <div *ngIf="activity?.activityFishing" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="fishing"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Fishing</div>
      </div>
      <div *ngIf="activity?.activityGolf" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="golf"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Golf</div>
      </div>
      <div *ngIf="activity?.activityHiking" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="hiking"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Hiking</div>
      </div>
      <div *ngIf="activity?.activityHorseback" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="horseback"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Horseback Riding</div>
      </div>
      <div *ngIf="activity?.activityHunting" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="hunting"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Hunting</div>
      </div>
      <div *ngIf="activity?.activityKayaking" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="kayaking"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Kayaking</div>
      </div>
      <div *ngIf="activity?.activityMotorSports" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="motorSports"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Motor Sports</div>
      </div>
      <div *ngIf="activity?.activityOhv" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="ohv"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">OHV Trails</div>
      </div>
      <div *ngIf="activity?.activityRafting" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="rafting"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Rafting</div>
      </div>
      <div *ngIf="activity?.activityRockClimbing" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="rockClimbing"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Rock Climbing</div>
      </div>
      <div *ngIf="activity?.activitySnowSports" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="snowSports"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Snow Sports</div>
      </div>
      <div *ngIf="activity?.activitySurfing" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="surfing"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Surfing</div>
      </div>
      <div *ngIf="activity?.activitySwimming" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="swimming"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Swimming</div>
      </div>
      <div *ngIf="activity?.activityWaterSports" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="waterSports"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Water Sports</div>
      </div>
      <div *ngIf="activity?.activityWildlifeWatching" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="wildlifeWatching"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Wildlife Watching</div>
      </div>
      <div *ngIf="activity?.activityWindSports" class="cnt-button categories">
        <div class="cnt-button-icon">
          <curbnturf-site-svgs type="windSports"></curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">Wind Sports</div>
      </div>
      <div *ngIf="activity?.customActivity" class="cnt-button categories">
        <div class="cnt-button-copy">
          {{ activity?.customActivity }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="horz-line _18px"></div>
<div>
  <h4 *ngIf="activity?.name">
    {{ activity?.name || '&nbsp;' }}
  </h4>
  <h5 *ngIf="activity?.getThingsToDo()" class="things-to-do">
    {{ activity?.getThingsToDo() }}
  </h5>
  <h5 *ngIf="activity?.getLocation()" class="location">
    {{ activity?.getLocation() }}
    <span *ngIf="!activity?.address?.address"> (nearest city) </span>
  </h5>
</div>
<div *ngIf="activity?.description">{{ activity?.description }}</div>
<div *ngIf="activity?.phone" class="poi-phone">
  <em>Phone Number: {{ activity?.phone | cntMaskPhone }}</em>
</div>
<a *ngIf="activity?.url" href="{{ activity?.url }}" class="link" target="_blank">
  {{ activity?.url }}
</a>
<div *ngIf="activity?.photos?.length > 0" class="horz-line _18px"></div>
<div *ngIf="activity?.photos?.length > 0" class="poi-images">
  <ng-container *ngFor="let photo of activity?.photos; let i = index">
    <img
      alt="photo.caption"
      class="activity-image"
      (click)="openPhotoModal(photo)"
      [src]="getPhotoUrl(photo)"
      *ngIf="i < 2 || showAll"
    />
  </ng-container>
  <a class="link" (click)="showAll = true" *ngIf="activity?.photos?.length > 2 && !showAll"> More images... </a>
</div>

<div class="horz-line _18px"></div>

<curbnturf-location-map [activities]="activityArray"> </curbnturf-location-map>
